module.exports = __webpack_public_path__ + "img/RestoPartner-1.6730e974.png";